module.exports = __webpack_public_path__ + "static/media/read-message2.d43196a7.svg";